module.exports = __webpack_public_path__ + "static/media/logo_wbs_akademie.7ad5617c.svg";